import { render, staticRenderFns } from "./TraineeDetails.vue?vue&type=template&id=ab6fdb4c&"
import script from "./TraineeDetails.vue?vue&type=script&lang=js&"
export * from "./TraineeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports